
<div class="container-fluid banner">
    <img src="../../assets/provider.jpg" class="img-responsive" style="width: 100%;">
    <div class="top-left">
        <h1 class="h1">Our EMR can Serve You Best <br>Experience it 
            <!-- <a class="bb2" target="_blank" routerLink="/emr-registration" type="button"><img src="../../assets/Btn-gif.gif"  class="img"></a> -->
            <a class="btn bb2"  target="_blank" routerLink="/emr-registration" type="button">FOR FREE</a>
    </h1>
    </div>
  </div><br>
<div class="container-fluid back">
    <div class="row middle1">
        <div class="col-md-6 col-md-offset-2 col-xs-12 col-xs-offset-4 middle col-sm-8 col-sm-offset-2 middle">
        <div class="column">
            <img src="assets/i4.png" alt="Avatar" class="avatar">
            <figcaption>Credential</figcaption>
        </div>
        <div class="column">
          <img src="assets/i3.png" alt="Avatar" class="avatar">
        <figcaption>Orientation & Education</figcaption>
        </div>
        <div class="column">
            <img src="assets/i5.png" alt="Avatar" class="avatar">
            <figcaption>Provider Manual</figcaption>
        </div>
          <div class="column">
            <img src="assets/i7.png" alt="Avatar" class="avatar">
            <figcaption>Forms & Tools</figcaption>
        </div>
        <div class="column">
            <img src="assets/i6.png" alt="Avatar" class="avatar">
            <figcaption>Case Management</figcaption>
        </div>
      

      </div>

    </div>



  </div>

<div class="container join">
   
<div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="box boxsmall">
            <h5>Join Hands in Saving Lives </h5>
            <p>As the world fights a pandemic it becomes necessary for more helping hands to come forward to boost immunity which in return would save lives. Here we are opening this platform for all those large-hearted medical experts to reach out to those in need at these hard times.
            </p>
        </div>

    </div>
    <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="box2">
        <img src="assets/Join-image.jpg" class="img-responsive">
    </div>
        
    </div>
</div>
<div class="row">
    <h2>How To Go About It</h2>
    <p>If you are a specialist in handling any health condition and are interested in reaching out to a larger population, just enter your details here and let us do the background work. All that you need to do is:
    </p>
    <p><i class="glyphicon glyphicon-arrow-right"></i> Enter your basic details in the form below</p>
    <p><i class="glyphicon glyphicon-arrow-right"></i> Fill up the inputs required on the credentialing tab on top of the page</p>
    <p><i class="glyphicon glyphicon-arrow-right"></i> We will run through the details given and get back to you</p>
    <p><i class="glyphicon glyphicon-arrow-right"></i> Once we agree to work together you can run through the inputs on the Orientation and Education tab</p>
    <p><i class="glyphicon glyphicon-arrow-right"></i> The Provider Manual acts as your step by step guide</p>
    <p><i class="glyphicon glyphicon-arrow-right"></i> We offer Forms and Tools that can come in handy</p>
    <p><i class="glyphicon glyphicon-arrow-right"></i>  Case Management contains info and health updates of the patients you will be handling at the time of consultation</p>
<button class="btn bb"><a routerLink="/registration">CLICK TO REGISTER</a></button>
</div>
   
</div>
<!-- <div class="container">
    <div class="row row1">
    <h3>LANGUAGE CENTER</h3>
    <p>ATTENTION: If you speak English, language assistance services, free of charge, are available to you. Call 1-866-814-7773 (TTY: 3-2-9).</p>
    <p>View our multi-language assistance and non-discrimination notices.</p>
</div>
<div class="container row1">
    <div class="col-lg-4">English &nbsp;<img src="assets/Language-Doc.jpg"></div>
    <div class="col-lg-4">Français (French)&nbsp;<img src="assets/Language-Doc.jpg"></div>
    <div class="col-lg-4">Español (Spanish)&nbsp;<img src="assets/Language-Doc.jpg"></div>
</div>
</div> -->
